export default "/fonts/lato-light-webfont.ttf?b457f8624337d42bcec0c357c99e98ad";